import type { PlanInfo } from "@/types/billing";

/** Logika flagi — osobna funkcja ułatwia testy jednostkowe (bez polegania na `import.meta` w asercjach). */
export function computeShareableLink(dev: boolean, viteEnableShare: unknown): boolean {
  return dev || viteEnableShare === "true";
}

export const FEATURES = {
  shareableLink: computeShareableLink(
    import.meta.env.DEV,
    import.meta.env.VITE_ENABLE_SHARE
  ),
};

export type FeatureFlags = ReturnType<typeof getFeatures>;

/** Flagi zależne od planu / triala. `dev` opcjonalnie — do testów bez `import.meta`. */
export function getFeatures(planInfo: PlanInfo, opts?: { dev?: boolean }): FeatureFlags {
  const dev = opts?.dev ?? import.meta.env.DEV;
  const isPro = planInfo.canUseProFeatures;
  return {
    shareableLink: isPro || dev,
    pdfNoBranding: isPro,
    unlimitedPublications: isPro,
    companyBranding: isPro,
    offerHistory: isPro,
  };
}
